import { NavLink, useHistory } from "react-router-dom";
import NavUserInfo from "./nav-user-info/NavUserInfo";
import { ROUTES } from "../../../routing/routes";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { AuthState } from "../../../context/auth/auth/reducer";
import { History } from "history";
import _environment from "../../../_environment/_environment";

// jQuery
declare const $: any;

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
}

const Navbar = ({ ...restProps }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // Access to the history instance that you may use to navigate.
  let history = useHistory();

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------
  const { user } = useSelector(({ authReducer }: { authReducer: AuthState }) => {
    return authReducer;
  });

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // init component
      console.log("[Navbar] init");

    // jQuery for menu toggle
    $(".menu-toggle").on("click", () => {
      $(".menu").toggle();
    });
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // destroy component
      console.log("[Navbar] destroy");
    // destroy all
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();

    return () => {
      destroy();
    };
  }, []);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <nav className="navbar">
      <div
        className="logo"
        onClick={() => {
          history.push(ROUTES.HOME);
        }}
      >
        <img src={_environment.assets.logo} alt="Meeters" />
      </div>

      <div className="menu">
        <div className="nav-item">
          <NavLink
            to={ROUTES.HOME}
            exact={true}
            activeClassName="font-weight-bold"
            className="nav-link text-dark"
          >
            {t(`nav.${user ? "home" : "signIn"}`)}
          </NavLink>
        </div>
        {user && (
          <>
            <div className="nav-item">
              <NavLink
                to={ROUTES.STANDS}
                activeClassName="font-weight-bold"
                className="nav-link text-dark"
              >
                {t("nav.stands")}
              </NavLink>
            </div>

            <div className="nav-item">
              <NavLink
                to={ROUTES.EVENTS}
                activeClassName="font-weight-bold"
                className="nav-link text-dark"
              >
                {t("nav.events")}
              </NavLink>
            </div>

            <div className="nav-item">
              <NavLink
                to={ROUTES.CHAT}
                activeClassName="font-weight-bold"
                className="nav-link text-dark"
              >
                {t("nav.chat")}
              </NavLink>
            </div>

            <div className="nav-item">
              <NavLink
                to={ROUTES.SEARCH}
                activeClassName="font-weight-bold"
                className="nav-link text-dark"
              >
                {t("nav.search")}
              </NavLink>
            </div>
          </>
        )}
      </div>

      {user && (
        <div className="profile">
          <div className="menu-toggle">
            <i className="fas fa-bars"></i>
          </div>
          <NavUserInfo />
        </div>
      )}
    </nav>
  );
};
export default Navbar;
